import { useEffect, useRef, useState } from "react";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { data } from "./AddUser.config";
import { gql, useMutation } from "@apollo/client";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";

import { handleFormReset } from "../../FormInputSectionComponent/formUtils";

const CREATE_USER = gql`
  mutation AddUserToAccount($signupInputRootUser: RootUserInput!, $Account_ID: ID) {
    AddUserToAccount(signupInputRootUser: $signupInputRootUser, Account_ID: $Account_ID) {
      message
    }
  }
`;

export const AddUser = ({ show, TypeOfPortal, fielddata, submitType, AccountId, setOpenAddUser }) => {
  let Form_Key = "Add_EMT_User";
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const formRef = useRef({});
  const [toggle, settoggle] = useState(show);
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();

  const [CreatingData, { loading }] = useMutation(CREATE_USER, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const handleErrorsChange = (newErrors) => {
    // debugger;
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const { executeOperation } = useSubmitOperation();
  const operationType = "Add";
  let formData = FormData;

  if (operationType === "Merge") {
    formData.existingId = allFieldsData?._id;
    formData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
  }

  const variables = usePrepareGraphQLVariables(
    operationType,
    allFieldsData,
    formData,
    selectedRows,
    "signupInputRootUser"
  );

  const mutationFunctions = {
    CreatingData,
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);

    if (!Error) {
      console.log(Error, "formErrorsformErrorsformErrors");
      submit();
    }
  };

  const HanldeChangeonForm = (values) => {
    // console.log(values, "Formdata_without_redux1");
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const submit = (closeAction) => {
    variables.Account_ID = AccountId;
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    console.log(mutationFunction);

    const executeOperationFunction = () => {
      console.log(variables);
      return executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: true,
        PageName: Form_Key,
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: handleFormReset(formRef),
      onSuccess: () => {},
      onError: (error) => {},
    });
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
  };
  const Closeformfunction = () => {
    setOpenAddUser(false);
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);

    setAllFieldsData({});
  };
  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);
  const FooterContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      // submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      TypeOfPortal={TypeOfPortal}
      Form_key={Form_Key}
      SaveAndClose={() => {
        Validate_handleSubmit(SaveAndCloseForAdd);
      }}
      handleformclose={() => {
        Closeformfunction();
      }}
      loadingState={loading}
    />
  );

  return (
    <div>
      <Reactportal
        FoooterContent={FooterContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"Add User"}
        TypeOfId={"Account Id :"}
        id={""}
      >
        <div className={"formContainer"}>
          {data?.map((el, i) => {
            return (
              <div className="singleSection">
                <FormInputSectionComponent
                  TypeOfPortal={TypeOfPortal}
                  inputfields={el.fields}
                  accountId=""
                  Type={el.name}
                  onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                  formkey={Form_Key}
                  onhandleFormikChange={HanldeChangeonForm}
                  formRef={formRef}
                />
                <br />
              </div>
            );
          })}
        </div>
      </Reactportal>
    </div>
  );
};
